import { format } from 'date-fns';

export const getTodaysDate = () => format(new Date(), 'yyyy-MM-dd');
export const ONELIFE_URL = process.env.REACT_APP_ONELIFE_URL;

export const SCHEDULE_EDITOR_LEGACY_PATH = '/schedule/omni-msa';
export const SCHEDULE_EDITOR_PATH = '/schedule/schedule-editor';
